import React, { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import ScrollContainer from "react-indiana-drag-scroll";
import Cookies from "js-cookie";
import arrow1 from "../../assets/image 13 (Traced).png";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import VideoFrame from "../Modal/VideoFrame";
import RaceModal from "../Modal/RaceModal";
import JockeyDetail from "../Modal/JockeyModal";
import HorseModal from "../Modal/HorseModal";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import Animate from "../../assets/loader.json";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Moment from "react-moment";
import { IoMdPlay } from "react-icons/io";
import { truncateRaceType, formatDateStandard } from "../../service/stringUtils";


// Isolated Style Import
// import "./TrackRecordNew.css"; 

const TrackRecord = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const cookiedata = Cookies.get("i18next");
    const { data: TrackRecord, status } = useSelector((state) => state.TrackRecord);

    // Modal States Preserved
    const [show, setShow] = useState(false);
    const [modaldata, setmodaldata] = useState();
    const handleClose = () => setShow(false);
    const handleShow = (data) => { const id = data?._id || data; if (id) navigate("/horse-detail?" + id); };

    const [showRace, setShowRace] = useState(false);
    const [modaldataRace, setmodaldataRace] = useState();
    const handleCloseRace = () => setShowRace(false);
    const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };

    const [showJockey, setShowJockey] = useState(false);
    const [modaldataJockey, setmodaldataJockey] = useState();
    const handleCloseJockey = () => setShowJockey(false);
    const handleShowJockey = (data) => { const id = data?._id || data; if (id) navigate("/jockey-detail?" + id); };

    const [showHorse, setShowHorse] = useState(false);
    const [modaldataHorse, setmodaldataHorse] = useState();
    const handleCloseHorse = () => setShowHorse(false);
    const handleShowHorse = (data) => {
        const id = data?._id || data;
        if (id) navigate("/horse-detail?" + id);
    };

    const FirstLetter = (data) => data ? data.substring(0, 1) : "";

    function distanceLabel(distance, rank) {
        const d = parseFloat(distance);
        if (!d) return distance;
        if (d.toFixed(2) > 25) return "Dist";
        if (d.toFixed(2) == 0.05 && rank < 80) return "SHd";
        if (d.toFixed(2) == 0.1 && rank < 80) return "Hd";
        if (d.toFixed(2) == 0.25 && rank < 80) return "Nk";
        if (d.toFixed(2) == 0.01 && rank < 80) return "Ns";
        if (d.toFixed(2) == 0.0 && rank < 80) return rank === 1 ? 0 : "Dh";
        return distance;
    }

    const toTitleCase = (str) => {
        if (!str) return "-";
        return str
            .toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    return (
        <div className="track-new-master-wrapper">
            <ScrollContainer className="track-new-scroll-container">
                <div className="track-new-content-area">
                    {status === "loading" ? (
                        <div className="text-center py-4"><Lottie animationData={Animate} style={{ width: 100, margin: 'auto' }} /></div>
                    ) : TrackRecord && TrackRecord?.length === 0 ? (
                        <SkeletonTheme baseColor="#00A6A7" highlightColor="#9DD9DB">
                            <p><Skeleton count={5} height={50} style={{ marginBottom: '10px' }} /></p>
                        </SkeletonTheme>
                    ) : (
                        <div className="new-bottom-history-section">

                            {/* --- DIV BASED HEADER (16 COLUMNS) --- */}
                            <div className="track-new-grid-thead">
                                <div>{window.textTransform(t("Date"))}</div>
                                <div>{window.textTransform(t("Crs"))}</div>
                                <div>{window.textTransform(t("Horse Name"))}</div>
                                <div>{window.textTransform(t("Dist"))}</div>
                                <div>{window.textTransform(t("RT"))}</div>
                                <div>{window.textTransform(t("Time"))}</div>
                                <div>{window.textTransform(t("Jockey"))}</div>
                                <div>{window.textTransform(t("Wgt"))}</div>
                                <div>{window.textTransform(t("FP"))}</div>
                                <div>{window.textTransform(t("Len"))}</div>
                                <div>{window.textTransform(t("RN"))}</div>
                                <div>{window.textTransform(t("BtBy"))}</div>
                                <div>{window.textTransform(t("Kgs"))}</div>
                                <div>{window.textTransform(t("Draw"))}</div>
                                <div>{window.textTransform(t("OR"))}</div>
                                <div></div>
                            </div>

                            {/* --- DIV BASED BODY ROWS --- */}
                            <div className="track-new-grid-tbody">
                                {TrackRecord.map((item, i) => {
                                    const groundType = item?.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                                    const rowColorClass = groundType === "Dirt" ? "track-new-row-dirt" : groundType === "Turf" ? "track-new-row-turf" : "track-new-row-default";

                                    return (
                                        <div key={i} className={`track-new-grid-row-card ${rowColorClass}`}>

                                            {/* Date */}
                                            <div onClick={() => {
                                                handleShowRace(item?.RaceID);
                                                navigate(`/race-detail?${item?.RaceID}`);
                                            }} className="track-new-clickable-td">
                                                {formatDateStandard(item?.RaceResultData?.StartTime)}
                                            </div>

                                            {/* Course */}
                                            <div>
                                                {cookiedata === "en" ? item?.RaceResultData?.RaceCourseData?.AbbrevEn : item?.RaceResultData?.RaceCourseData?.AbbrevAr}
                                                ({FirstLetter(cookiedata === "en" ? groundType : item?.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameAr)})
                                            </div>

                                            {/* Horse Name */}
                                            <div className="track-new-clickable-td track-new-truncate-text" onClick={() => handleShowHorse(item?.HorseIDData)}>
                                                {cookiedata === "en" ? window.textTransform(item?.HorseIDData?.NameEn || item?.HorseModelIdData1?.NameEn || "-") : (item?.HorseIDData?.NameAr || item?.HorseModelIdData1?.NameAr || "-")}
                                            </div>

                                            {/* Track Length (Dist) */}
                                            <div>{item?.RaceResultData?.TrackLengthData?.TrackLength}</div>

                                            {/* Race Type (with Tooltip preserved) */}
                                            <div className="track-new-tooltip-cell">
                                                <OverlayTrigger overlay={<Tooltip>{cookiedata === "en" ? item?.RaceResultData?.RaceTypeModelData?.NameEn : item?.RaceResultData?.RaceTypeModelData?.NameAr}</Tooltip>}>
                                                    <span>{toTitleCase(cookiedata === "en" ? truncateRaceType(item?.RaceResultData?.RaceTypeModelData?.NameEn) : item?.RaceResultData?.RaceTypeModelData?.NameAr)}</span>
                                                </OverlayTrigger>
                                            </div>

                                            {/* Time */}
                                            <div>{item?.RaceTime}</div>

                                            {/* Jockey */}
                                            <div onClick={() => handleShowJockey(item.JockeyOnRaceDataResult || "")} className="track-new-clickable-td">
                                                {cookiedata === "en" ? window.textTransform(item?.JockeyOnRaceDataResult?.ShortNameEn) : item?.JockeyOnRaceDataResult?.ShortNameAr}
                                            </div>

                                            {/* Wgt (Weight of the horse) */}
                                            <div>{item?.HorseIDData?.JockeyWeightOfHorse || item.JockeyWeight || item.Weight || item.JockeyRaceWeight || item.RaceResultData?.JockeyRaceWeight || item.RaceResultData?.RacehorsesData?.[0]?.JockeyRaceWeight || item.HorseIDData?.Weight || "-"}</div>

                                            {/* Position (FP) */}
                                            <div>{item.FinalPositionDataHorse ? (cookiedata === "en" ? item.FinalPositionDataHorse.NameEn : item.FinalPositionDataHorse.NameAr) : "-"}</div>

                                            {/* Distance (Len) */}
                                            <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>

                                            {/* Runners (RN) */}
                                            <div>{item.Runners || 0}</div>

                                            {/* Beaten By */}
                                            {(() => {
                                                const rank = item?.FinalPositionDataHorse?.Rank;
                                                const targetHorse = rank === 1
                                                    ? (item?.RunnerUpData || item?.BeatenByData || null)
                                                    : (item?.WinnerData || item?.BeatenByData || null);
                                                const targetName = targetHorse
                                                    ? (cookiedata === "en" ? window.textTransform(targetHorse.NameEn || "") : (targetHorse.NameAr || targetHorse.NameEn || "-"))
                                                    : (cookiedata === "en"
                                                        ? window.textTransform(item?.HorseIDData?.HorseBeatenByEnglishName || "")
                                                        : (item?.HorseIDData?.HorseBeatenByArabicName || item?.HorseIDData?.HorseBeatenByEnglishName || "-"));
                                                const targetId = targetHorse?._id || item?.BeatenByData?._id;
                                                const targetWeight = targetHorse?.WinningHorseJockeyWeight ?? item?.BeatenByData?.WinningHorseJockeyWeight ?? item?.HorseIDData?.BeatenByJockeyWeight ?? 0;

                                                return (
                                                    <>
                                                        <div
                                                            className={`track-new-truncate-text ${targetId ? "track-new-clickable-td" : ""}`}
                                                            title={targetName || ""}
                                                            onClick={() => targetId && handleShowHorse(targetId)}
                                                            style={{ cursor: targetId ? "pointer" : "default" }}
                                                        >
                                                            {targetName || "-"}
                                                        </div>
                                                        <div>{targetWeight}</div>
                                                    </>
                                                );
                                            })()}

                                            {/* Draw */}
                                            <div>{item?.HorseIDData?.GateNoOfHorse || "-"}</div>

                                            {/* OR */}
                                            <div>{item?.Rating || 0}</div>

                                            {/* Link (Play Button) */}
                                            <div className="track-new-play-cell">
                                                <div className="track-new-play-btn-circle" onClick={() => handleShow(item.VideoLink)}>
                                                    <IoMdPlay />
                                                </div>
                                            </div>

                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </ScrollContainer>

            {/* --- ALL MODALS PRESERVED --- */}
            <Modal show={show} onHide={handleClose} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><VideoFrame data={modaldata} /></Modal.Body></Modal>
            <Modal show={showJockey} onHide={handleCloseJockey} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><JockeyDetail data={modaldataJockey} /></Modal.Body></Modal>
            <Modal show={showRace} onHide={handleCloseRace} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><RaceModal id={modaldataRace} /></Modal.Body></Modal>
            <Modal show={showHorse} onHide={handleCloseHorse} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><HorseModal data={modaldataHorse} /></Modal.Body></Modal>
        </div>
    );
};
export default TrackRecord;